import CurrencyMixin from 'mixins/currency-mixin'

export default {
  props: {
    title: {
      required: true,
      type: String
    },
    locationNameWithPreposition: {
      required: true,
      type: String
    },
    seoData: {
      type: Object,
      required: true
    },
    place: {
      type: Object,
      required: true
    },
    isAirport: {
      required: false,
      default: false,
      type: Boolean
    }
  },

  mixins: [CurrencyMixin],

  data() {
    return {
      selected: undefined,
      showBestCompanies: false
    }
  },

  mounted() {
    $('.tooltipped').tooltip({ delay: 0 })

    if (this.seoData?.nps?.length > 0) {
      this.showBestCompanies = true
    }

    setTimeout(() => {
      const lista = []
      for (let i = 0; i < this.seoData.ticketMonths.length; i++) {
        lista.push(this.seoData.ticketMonths[i].ticket)
      }
      const result = lista.indexOf(Math.min(...lista))
      this.selected = result

      $('#' + this.selected).trigger('mouseenter.tooltip')
      setTimeout(function () {
        $('#' + this.selected).trigger('mouseleave.tooltip')
      }, 1000)

      const tooltips = document.getElementsByClassName('material-tooltip')
      if (tooltips.length > 12) {
        for (const i in tooltips) {
          i < 12 ? tooltips[i].setAttribute('style', 'display: none') : tooltips
        }
      }

      document.getElementsByClassName('graphic')[0].onclick = function (e) {
        const tp = document.getElementById(document.getElementById(result).getAttribute('data-tooltip-id'))
        tp.style.visibility = 'hidden'
      }
    }, 2000)
  },

  destroyed () {
    $('.tooltipped').tooltip('destroy')
  }
}
